import { useMutation } from "react-query";
import { downgradeToFreePlan } from "../services/api";
import { Organization } from "../types";

export const useDowngradeToFreePlan = (organizationId: Organization["uid"]) => {
  return useMutation(() => downgradeToFreePlan(organizationId));
};
